import translations from './translations'

translations.add('es', {
    poweredBy: 'Con tecnología de'
})
